import { Navigate, useLocation } from "react-router-dom";
import { authService } from "../services/api";
import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [emailVerified, setEmailVerified] = useState(true);

  useEffect(() => {
    const checkUserStatus = async () => {
      if (!isAuthenticated) {
        setChecking(false);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        const verified = response.data.email_verified !== false;
        setEmailVerified(verified);
      } catch (err) {
        console.error("Error checking user status:", err);
        setEmailVerified(true);
      } finally {
        setChecking(false);
      }
    };

    checkUserStatus();
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-purple mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!emailVerified) {
    const searchParams = new URLSearchParams(location.search);
    const plan = searchParams.get("plan");
    const verifyUrl = plan ? `/verify-email?plan=${plan}` : "/verify-email";
    return <Navigate to={verifyUrl} replace />;
  }

  // Allow pending_payment users to access dashboard in trial/preview mode
  return children;
};
